export const STAYS_ERROR_TYPES = {
  ROOM_TRAVELER_MISMATCH: 'staysRoomTravelerMismatch',
  ROOM_MISMATCH: 'staysRoomMismatch',
  MAX_DATE_MISMATCH: 'maxDateMismatch'
} as const;

export type StaysErrorType =
  (typeof STAYS_ERROR_TYPES)[keyof typeof STAYS_ERROR_TYPES];
